import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, Mail, Phone } from "lucide-react";
import { api, brand } from "@/lib/api";
import { WaveTop } from "@/components/Deco";

export default function Footer() {
  const [content, setContent] = useState({});
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data || {})).catch(() => {});
  }, []);

  return (
    <footer className="mt-16" data-testid="footer">
      <WaveTop color="#292634" />
      <div className="bg-ink text-cream">
        <div className="section py-12 grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <span className="inline-block bg-cream rounded-2xl p-3 border-[3px] border-cream">
              <img src={brand.logo} alt="Paint With Tay" className="h-16 sm:h-20 w-auto" data-testid="brand-logo" />
            </span>
            <p className="mt-4 max-w-sm text-cream/80 font-body">
              Fun, professional face painting for birthdays, markets, schools and special events throughout {content.service_area || "Nanaimo and surrounding communities"}.
            </p>
            <div className="mt-4 flex items-center gap-2 text-sunshine">
              <MapPin className="w-5 h-5" />
              <span className="font-600">Nanaimo, British Columbia</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-sunshine mb-3">Explore</h4>
            <ul className="space-y-2 font-body">
              <li><Link to="/services" className="hover:text-hotpink">Services</Link></li>
              <li><Link to="/gallery" className="hover:text-hotpink">Gallery</Link></li>
              <li><Link to="/about" className="hover:text-hotpink">About Tay</Link></li>
              <li><Link to="/faqs" className="hover:text-hotpink">FAQs</Link></li>
              <li><Link to="/book" className="hover:text-hotpink">Book Now</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-sunshine mb-3">Get in touch</h4>
            <ul className="space-y-2 font-body">
              <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> {content.contact_email || "paintwithtay@gmail.com"}</li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> {content.contact_phone || "403-795-6705"}</li>
              <li>
                <a href={brand.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-hotpink" data-testid="footer-instagram">
                  <Instagram className="w-4 h-4" /> @paint.with.tay
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cream/20">
          <div className="section py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-cream/70">
            <p>© {new Date().getFullYear()} Paint With Tay. All rights reserved.</p>
            <div className="flex gap-4">
              <Link to="/privacy" className="hover:text-cream">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-cream">Booking Terms</Link>
              <Link to="/admin" className="hover:text-cream">Admin</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
